angular.module('app.filters').filter('simulcast_destination', () => {
  'ngInject';
  return function (destination) {
    switch (destination) {
      case 'facebook':
        return 'Facebook Live';
      case 'youtube':
        return 'YouTube Live';
      case 'generic':
        return 'Other RTMP';
      case 'rtmp_push_channel':
        return 'Other RTMP';
      case 'twitter':
        return 'Twitter';
      default:
        console.warn('Invalid simulcast_destination', destination);
        return `(invalid destination type: ${destination})`;
    }
  };
});



// WEBPACK FOOTER //
// ./app/filters/simulcast-destination.js